// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plans_planCardSection__klnqS {
    height: 900px;
}
.plans_planSectionContactTxt__G51dK{
    color: #1b1b1b;
    margin: 20px 0px;
}

.plans_happyCustomer__9K4s- {
    height: fit-content;
    padding: 200px 100px 100px 100px;

}

.plans_cardContent__1uBJn {
    width: 350px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.plans_planTextList__8Dich {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    text-align: left;
}

.plans_UserAvatar__ZjEgJ {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    text-align: left;
    align-items: center;
}

.plans_customerAvater__TC9ne {
    margin-right: 10px;
}

.plans_description__X8WoD {
    align-items: center;
    text-align: center;
    justify-content: center;
}

.plans_topic__JJeVy {
    font-size: 3rem;
    font-style: normal;
    font-weight: 600;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
}

.plans_planCardOuter__H9\\+L8 {
    margin-top: 100px;
}

.plans_PlanCardContainerouter__byBZv {
    z-index: 0;
}

.plans_PlanCardContainer__NBJNW {
    position: relative;
    /* background-color: rgb(0, 0, 0); */
    border-radius: 200px 200px 0px 0px;
    height: 750px;
    margin-top: 250px;
    z-index: 1;
}

.plans_planCardCom__SQ-yn {
    position: absolute;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: -200px;
    left: 50%;
    transform: translate(-50%);
    width: fit-content;
    margin-bottom: 100px;
    z-index: 2;
}

.plans_plancardBackgroud__OnDXm {
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    padding: 50px;
    top: 200px;
    height: 480px;
    width: 100%;

}

.plans_planCard__5T7rZ {
    width: 350px;
    height: 600px;
    border-radius: 20px;
    margin: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    padding-top: 50px;
    padding-bottom: 50px;
    position: relative;
    z-index: 1;
    transition: all 0.5s ease;
}

.plans_planCardContent__LHb0k {
    z-index: 3;
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.plans_planPoints__KgP5a {
    line-height: 30px;
}

.plans_planCardCircle__bZYH- {
    width: 400px;
    height: 400px;
    background: linear-gradient(180deg, #322fd7 0%, #5b56c0 100%);
    border-radius: 400px;
    position: absolute;
    z-index: 2;
    top: -50px;
    right: -400px;
    transition: all 0.5s ease;
}

.plans_planCard__5T7rZ:hover {
    background: linear-gradient(180deg, #06056c 0%, #1109a7 100%);
    ;
    width: 370px;
    height: 620px;
    line-height: 20px;
    animation-name: plans_cardPopup__b4ZcE;
    animation-duration: 1s;
    animation-delay: -1s
}

.plans_planCard__5T7rZ:hover .plans_planCardCircle__bZYH- {
    right: -100px;
}

.plans_planCard__5T7rZ:hover .plans_planPoints__KgP5a {
    color: #ffffff;
}

.plans_planPointsHader__ca\\+6x {
    margin: 20px 0px;
    font-weight: 800;
    color: #010888;
}

.plans_planCard__5T7rZ:hover .plans_planPointsHader__ca\\+6x {
    color: #ffffff;
}

.plans_CardSubscribeBtn__Dmr6K {
    color: #ffffff;
    background-color: #25239c;

}

.plans_planCard__5T7rZ:hover .plans_CardSubscribeBtn__Dmr6K {
    color: #010888;
    background-color: #ffffff;

}
.plans_dialogSendButton__VP7LX {
    padding: 10px 15px;
    font-size: 16px;
    border-radius: 5px;
    background-color: #5fa9e0;
    box-shadow: none;
}
.plans_btnMainDialogComp__tVRig{
    align-items: center;
    text-align: center;
}
.plans_contactDilaogImage__k5lX\\+{
    width: 100px;
}
@keyframes plans_cardPopup__b4ZcE {
    0% {
        width: 350px;
        height: 550px;
    }

    25% {
        width: 355px;
        height: 560px;
    }

    50% {
        width: 360px;
        height: 570px;
    }

    75% {
        width: 365px;
        height: 580px;
    }

    100% {
        width: 370px;
        height: 620px;
    }
}

@media (max-width: 1200px) {
    .plans_cardContent__1uBJn {
        width: 250px;
        padding: 10px;

    }
    .plans_PlanCardContainer__NBJNW {
        border-radius: 100px 100px 0px 0px;
        height: 750px;
        margin-top: 250px;
    }

    .plans_planCard__5T7rZ {
        width: 250px;
        height: 420px;
        border-radius: 5px;
        margin: 5px;
        padding-top: 30px;
        padding-bottom: 30px;
        
    }
    
    .plans_planPoints__KgP5a {
        font-size: 10px;
        line-height: 18px;
    }
    
    .plans_planCardCircle__bZYH- {
        width: 300px;
        height: 300px;
        border-radius: 200px;
        top: -10px;
        right: -400px;
    }
    
    .plans_planCard__5T7rZ:hover {
        width: 270px;
        height: 450px;
        line-height: 20px;
    }
    
    .plans_planCard__5T7rZ:hover .plans_planCardCircle__bZYH- {
        right: -100px;
    }
    .plans_planPointsHader__ca\\+6x {
        font-size: 18px;
    }
    .plans_CardSubscribeBtn__Dmr6K{
        font-size: 8px;
    }

}

@media (max-width: 770px) {
    .plans_cardContent__1uBJn {
        width: 100%;
        padding: 10px;

    }
    .plans_planCardCom__SQ-yn {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }
.plans_PlanCardContainer__NBJNW{
    height: 1200px;
}
.plans_happyCustomer__9K4s- {
    padding: 650px 20px 20px 20px;

}
.plans_plancardBackgroud__OnDXm {
    padding: 10px;
    top: 0px;
    height: 100%;
}
.plans_planSectionContactTxt__G51dK{
    font-size: 16px;
}

}


@media (max-width: 660px) {
    .plans_happyCustomer__9K4s- {
        padding: 650px 10px 10px 10px;
    }

    .plans_topic__JJeVy {
        font-size: 32px;
        text-align: center;

    }
}`, "",{"version":3,"sources":["webpack://./src/components/home/plans.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;;AAEpC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,kCAAkC;IAClC,aAAa;IACb,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,0BAA0B;IAC1B,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,aAAa;IACb,WAAW;;AAEf;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,6DAA6D;IAC7D,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,6DAA6D;;IAE7D,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,sCAAyB;IACzB,sBAAsB;IACtB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;;AAE7B;;AAEA;IACI,cAAc;IACd,yBAAyB;;AAE7B;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,YAAY;AAChB;AACA;IACI;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;;IAEjB;IACA;QACI,kCAAkC;QAClC,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,WAAW;QACX,iBAAiB;QACjB,oBAAoB;;IAExB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,oBAAoB;QACpB,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,cAAc;IAClB;;AAEJ;;AAEA;IACI;QACI,WAAW;QACX,aAAa;;IAEjB;IACA;QACI,aAAa;QACb,eAAe;QACf,uBAAuB;IAC3B;AACJ;IACI,cAAc;AAClB;AACA;IACI,6BAA6B;;AAEjC;AACA;IACI,aAAa;IACb,QAAQ;IACR,YAAY;AAChB;AACA;IACI,eAAe;AACnB;;AAEA;;;AAGA;IACI;QACI,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,kBAAkB;;IAEtB;AACJ","sourcesContent":[".planCardSection {\r\n    height: 900px;\r\n}\r\n.planSectionContactTxt{\r\n    color: #1b1b1b;\r\n    margin: 20px 0px;\r\n}\r\n\r\n.happyCustomer {\r\n    height: fit-content;\r\n    padding: 200px 100px 100px 100px;\r\n\r\n}\r\n\r\n.cardContent {\r\n    width: 350px;\r\n    padding: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n}\r\n\r\n.planTextList {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    align-items: flex-start;\r\n    text-align: left;\r\n}\r\n\r\n.UserAvatar {\r\n    margin-top: 20px;\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    text-align: left;\r\n    align-items: center;\r\n}\r\n\r\n.customerAvater {\r\n    margin-right: 10px;\r\n}\r\n\r\n.description {\r\n    align-items: center;\r\n    text-align: center;\r\n    justify-content: center;\r\n}\r\n\r\n.topic {\r\n    font-size: 3rem;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    margin-bottom: 20px;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.planCardOuter {\r\n    margin-top: 100px;\r\n}\r\n\r\n.PlanCardContainerouter {\r\n    z-index: 0;\r\n}\r\n\r\n.PlanCardContainer {\r\n    position: relative;\r\n    /* background-color: rgb(0, 0, 0); */\r\n    border-radius: 200px 200px 0px 0px;\r\n    height: 750px;\r\n    margin-top: 250px;\r\n    z-index: 1;\r\n}\r\n\r\n.planCardCom {\r\n    position: absolute;\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    margin-top: -200px;\r\n    left: 50%;\r\n    transform: translate(-50%);\r\n    width: fit-content;\r\n    margin-bottom: 100px;\r\n    z-index: 2;\r\n}\r\n\r\n.plancardBackgroud {\r\n    position: absolute;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    padding: 50px;\r\n    top: 200px;\r\n    height: 480px;\r\n    width: 100%;\r\n\r\n}\r\n\r\n.planCard {\r\n    width: 350px;\r\n    height: 600px;\r\n    border-radius: 20px;\r\n    margin: 10px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    text-align: center;\r\n    align-items: center;\r\n    padding-top: 50px;\r\n    padding-bottom: 50px;\r\n    position: relative;\r\n    z-index: 1;\r\n    transition: all 0.5s ease;\r\n}\r\n\r\n.planCardContent {\r\n    z-index: 3;\r\n    position: absolute;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    text-align: center;\r\n}\r\n\r\n.planPoints {\r\n    line-height: 30px;\r\n}\r\n\r\n.planCardCircle {\r\n    width: 400px;\r\n    height: 400px;\r\n    background: linear-gradient(180deg, #322fd7 0%, #5b56c0 100%);\r\n    border-radius: 400px;\r\n    position: absolute;\r\n    z-index: 2;\r\n    top: -50px;\r\n    right: -400px;\r\n    transition: all 0.5s ease;\r\n}\r\n\r\n.planCard:hover {\r\n    background: linear-gradient(180deg, #06056c 0%, #1109a7 100%);\r\n    ;\r\n    width: 370px;\r\n    height: 620px;\r\n    line-height: 20px;\r\n    animation-name: cardPopup;\r\n    animation-duration: 1s;\r\n    animation-delay: -1s\r\n}\r\n\r\n.planCard:hover .planCardCircle {\r\n    right: -100px;\r\n}\r\n\r\n.planCard:hover .planPoints {\r\n    color: #ffffff;\r\n}\r\n\r\n.planPointsHader {\r\n    margin: 20px 0px;\r\n    font-weight: 800;\r\n    color: #010888;\r\n}\r\n\r\n.planCard:hover .planPointsHader {\r\n    color: #ffffff;\r\n}\r\n\r\n.CardSubscribeBtn {\r\n    color: #ffffff;\r\n    background-color: #25239c;\r\n\r\n}\r\n\r\n.planCard:hover .CardSubscribeBtn {\r\n    color: #010888;\r\n    background-color: #ffffff;\r\n\r\n}\r\n.dialogSendButton {\r\n    padding: 10px 15px;\r\n    font-size: 16px;\r\n    border-radius: 5px;\r\n    background-color: #5fa9e0;\r\n    box-shadow: none;\r\n}\r\n.btnMainDialogComp{\r\n    align-items: center;\r\n    text-align: center;\r\n}\r\n.contactDilaogImage{\r\n    width: 100px;\r\n}\r\n@keyframes cardPopup {\r\n    0% {\r\n        width: 350px;\r\n        height: 550px;\r\n    }\r\n\r\n    25% {\r\n        width: 355px;\r\n        height: 560px;\r\n    }\r\n\r\n    50% {\r\n        width: 360px;\r\n        height: 570px;\r\n    }\r\n\r\n    75% {\r\n        width: 365px;\r\n        height: 580px;\r\n    }\r\n\r\n    100% {\r\n        width: 370px;\r\n        height: 620px;\r\n    }\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n    .cardContent {\r\n        width: 250px;\r\n        padding: 10px;\r\n\r\n    }\r\n    .PlanCardContainer {\r\n        border-radius: 100px 100px 0px 0px;\r\n        height: 750px;\r\n        margin-top: 250px;\r\n    }\r\n\r\n    .planCard {\r\n        width: 250px;\r\n        height: 420px;\r\n        border-radius: 5px;\r\n        margin: 5px;\r\n        padding-top: 30px;\r\n        padding-bottom: 30px;\r\n        \r\n    }\r\n    \r\n    .planPoints {\r\n        font-size: 10px;\r\n        line-height: 18px;\r\n    }\r\n    \r\n    .planCardCircle {\r\n        width: 300px;\r\n        height: 300px;\r\n        border-radius: 200px;\r\n        top: -10px;\r\n        right: -400px;\r\n    }\r\n    \r\n    .planCard:hover {\r\n        width: 270px;\r\n        height: 450px;\r\n        line-height: 20px;\r\n    }\r\n    \r\n    .planCard:hover .planCardCircle {\r\n        right: -100px;\r\n    }\r\n    .planPointsHader {\r\n        font-size: 18px;\r\n    }\r\n    .CardSubscribeBtn{\r\n        font-size: 8px;\r\n    }\r\n\r\n}\r\n\r\n@media (max-width: 770px) {\r\n    .cardContent {\r\n        width: 100%;\r\n        padding: 10px;\r\n\r\n    }\r\n    .planCardCom {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        justify-content: center;\r\n    }\r\n.PlanCardContainer{\r\n    height: 1200px;\r\n}\r\n.happyCustomer {\r\n    padding: 650px 20px 20px 20px;\r\n\r\n}\r\n.plancardBackgroud {\r\n    padding: 10px;\r\n    top: 0px;\r\n    height: 100%;\r\n}\r\n.planSectionContactTxt{\r\n    font-size: 16px;\r\n}\r\n\r\n}\r\n\r\n\r\n@media (max-width: 660px) {\r\n    .happyCustomer {\r\n        padding: 650px 10px 10px 10px;\r\n    }\r\n\r\n    .topic {\r\n        font-size: 32px;\r\n        text-align: center;\r\n\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"planCardSection": `plans_planCardSection__klnqS`,
	"planSectionContactTxt": `plans_planSectionContactTxt__G51dK`,
	"happyCustomer": `plans_happyCustomer__9K4s-`,
	"cardContent": `plans_cardContent__1uBJn`,
	"planTextList": `plans_planTextList__8Dich`,
	"UserAvatar": `plans_UserAvatar__ZjEgJ`,
	"customerAvater": `plans_customerAvater__TC9ne`,
	"description": `plans_description__X8WoD`,
	"topic": `plans_topic__JJeVy`,
	"planCardOuter": `plans_planCardOuter__H9+L8`,
	"PlanCardContainerouter": `plans_PlanCardContainerouter__byBZv`,
	"PlanCardContainer": `plans_PlanCardContainer__NBJNW`,
	"planCardCom": `plans_planCardCom__SQ-yn`,
	"plancardBackgroud": `plans_plancardBackgroud__OnDXm`,
	"planCard": `plans_planCard__5T7rZ`,
	"planCardContent": `plans_planCardContent__LHb0k`,
	"planPoints": `plans_planPoints__KgP5a`,
	"planCardCircle": `plans_planCardCircle__bZYH-`,
	"cardPopup": `plans_cardPopup__b4ZcE`,
	"planPointsHader": `plans_planPointsHader__ca+6x`,
	"CardSubscribeBtn": `plans_CardSubscribeBtn__Dmr6K`,
	"dialogSendButton": `plans_dialogSendButton__VP7LX`,
	"btnMainDialogComp": `plans_btnMainDialogComp__tVRig`,
	"contactDilaogImage": `plans_contactDilaogImage__k5lX+`
};
export default ___CSS_LOADER_EXPORT___;
